import React, { useEffect } from "react";
import Slider from "./slider";
import About from "./About";
import Service from "./Service";
import Vision from "./Vision";
import Individuality from "./Individuality";
import Clients from "./Clients";
import { useController } from "../assets/components/BaseContrroler";
import { observer } from "mobx-react-lite";
import About2 from "./About2";

function Home() {
  const {
    baseController: { homeController },
  } = useController();
  const { setNavbar, setUrl } = homeController;

  useEffect(() => {
    setUrl("");
  });
  return (
    <div className="w-full overflow-hidden px-0 mx-0">
      <Slider />
      <About />
      <Service />
      <Vision />
      <About2 />
      <Clients />
      {/* <Individuality /> */}
    </div>
  );
}

export default observer(Home);
